<template>
  <div class="index" id="index">
       <div
      class="follow acea-row row-between-wrapper"
      v-if="followHid && isWeixin && isLogin"
    >
      <div>点击“立即关注”即可关注公众号</div>
      <div class="acea-row row-middle">
        <div class="bnt" @click="followTap">立即关注</div>
        <span class="iconfont icon-guanbi" @click="closeFollow"></span>
      </div>
    </div>
     <div class="followCode" v-if="followCode">
      <div class="pictrue"><img :src="followUrl" /></div>
      <div class="mask" @click="closeFollowCode"></div>
    </div>
	<div :class="discount_end_time.display ? 'activebg index_top' : 'noactivebg index_top'">
		<div @click="search" class="search"><span class="iconfont icon-sousuo sousuo"></span>{{discount_end_time.index_search_field}}</div>
		<ul class="menuslist">
			<li v-for="(item,key) in menus" :key="key" @click="menusclick(item.wap_url)">
				<dl>
					<dt>
						<img :src="menus_name == 'activity_pic' ? item.activity_pic : item.pic" alt="">
					</dt>
					<dd>{{item.name}}</dd>
				</dl>
			</li>
		</ul>
	</div>
	<!-- 弹框 -->
	<div id="mask" v-show="is_mask && is_new_goods_bananr == 1" >
		<img class="mask_img" :src="discount_end_time.new_goods_bananr" alt="" @click="$router.push(routine_jump_url)">
		<img class="mask_close" src="@assets/images/index_close.png" alt="" @click="is_mask = !is_mask">
	</div>
	<!-- 轮播 -->
    <div class="slider-banner banner">
		<img class="ad-img" v-if="adImg" @click="$router.push(adUrl)" :src="adImg" />
		<!-- <img src="@assets/images/active_banner.png" /> -->
      <swiper :options="swiperOption" v-if="activity_banner.length">
        <swiper-slide v-for="(item, index) in activity_banner" :key="index">
          <img :src="item" />
        </swiper-slide>
        <!-- <div class="swiper-pagination paginationBanner" slot="pagination"></div> -->
      </swiper>
    </div>
	<div v-if="productList1.length>0" class="zhuantiTop" id="activity">
		<img :src="zhuantiTop1">
	</div>
	<ul class="productlist">
		<li v-for="(item,key) in productList1" :key="key" @click="productClick(productListUrl[key])">
			<img :src="item" />
		</li>
	</ul>
	<div class="index_footer"><img :src="index_footer_img"></div>
	<hover-btn :kefu_display_status="kefu_display_status"></hover-btn>
  </div>
</template>
<script>

import { wechatEvevt } from "@libs/wechat";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import { getHomeData, follow } from "@api/public";
import {
  getProductDetail,
  postCartAdd,
  getCartCount,
  getProductCode,
  storeListApi
} from "@api/store";
import {
  getCoupon,
  getCouponReceive,
  getCollectAdd,
  getCollectDel,
  getUserInfo
} from "@api/user";
//import ProductWindow from "@components/ProductWindow";
import HoverBtn from "@components/HoverBtn";
import router from '../../router/index.js';
import { mapGetters } from "vuex";
export default {
  name: "IndexActivityNew",
  components: {
	  swiper,
	  swiperSlide,
	  HoverBtn,
	  //ProductWindow
  },
  props: {},
    computed: mapGetters(["isLogin"]),
  data: function() {
	let that = this;
    return {
    	is_mask: false,
		isWeixin: this.$wechat.isWeixin(),
		followUrl: "",
		followHid: false,
		subscribe: false,
		followCode: false,
		kefu_display_status: 2,
		banner:[],
		activity_banner: [],
		banner_jump_url: [],
		routine_jump_url: '',
		menus:[],
		menus_name:"",
		discount_end_time:{
			display:false,
			end_time:"",
			time:"",
			discount_end_text:"",
			title_img:"",
			images:"",
			jump_url:"",
			index_search_field:"",
			new_goods_bananr:"",
		},//倒计时
		is_coupon:"",
		is_new_goods_bananr:"",
		coupon_ids:[],
		zhuantiTop1:"",
		productList1:[],
		productListUrl:[],
		adImg:"",
		adUrl:"",
		swiperOption: {
		  pagination: {
		    el: ".paginationBanner",
		    clickable: true
		  },
		  autoplay: {
		    disableOnInteraction: false,//用户操作swiper之后，是否禁止autoplay。默认为true：停止
		    delay: 2000
		  },
		  loop: true,
		  speed: 1000,
		  observer: true,
		  observeParents: true,
		  on: {
		    tap: function() {
		      const realIndex = this.realIndex;
		      that.goUrl(realIndex);
		    }
		  }
		},
		index_footer_img: ""//底部图片
	}
  },
  created() {
    if (this.isLogin === false) {
      this.followHid = false;
    }
  },
  watch: {
    $route(n) {
		if (n.name === "IndexActivityNew") {
			this.getIndex();
			this.is_mask = false;
		}
    }
  },
  mounted: function() {
	  this.getFollow();
	  this.getIndex();
	  let winHeight = window.screen.height;
	  document.getElementById('mask').style.height = winHeight + 'px';
  },
  methods: {
	  get_yhq(coupon_id){
		let that = this;
		getCouponReceive(coupon_id)
		  .then(function() {
		    that.$dialog.toast({ mes: "领取成功" });
		  })
		  .catch(function(res) {
		    that.$dialog.toast({ mes: res.msg });
		  });
	  },
	  getIndex(){
		  var that = this;
		  var typeid = this.$route.params.typeid;
		  getHomeData(typeid).then(res => {
			  // console.log(res.data);
			  if(res.data.site_name && res.data.site_name != "学习严选"){
				  that.$cookies.set('title',res.data.site_name);
			  }else{
				  that.$cookies.remove('title');
			  }
			  document.title = res.data.site_name || this.$route.meta.title;
			  if(res.data.homepage_activity_info.display){
				  that.discount_end_time.display = res.data.homepage_activity_info.display;
				  that.discount_end_time.index_search_field = res.data.homepage_activity_info.index_search_field;
				  that.discount_end_time.new_goods_bananr = res.data.homepage_activity_info.new_goods_bananr;
				  that.zhuantiTop1 = res.data.homepage_activity_info.title_img;
				  that.productList1 = res.data.homepage_activity_info.images;
				  that.productListUrl = res.data.homepage_activity_info.jump_url;
				  that.is_new_goods_bananr = res.data.homepage_activity_info.is_new_goods_bananr;
				  that.activity_banner = res.data.homepage_activity_info.banner;
				  that.banner_jump_url = res.data.homepage_activity_info.banner_jump_url;
				  that.routine_jump_url = res.data.homepage_activity_info.routine_jump_url;
				  that.menus_name = res.data.homepage_activity_info.menus_name;
			  }else{
				  that.$router.replace('/');
				  return false;
			  }
			  that.banner = res.data.banner;
			  that.menus = res.data.menus;
			  that.index_footer_img = res.data.index_footer_img;
			  that.kefu_display_status = res.data.kefu_display_status;
			  that.adImg = res.data.newGoodsBananr.banner;
			  that.adUrl = res.data.newGoodsBananr.url;
			  that.is_mask = true;
			  if (that.isLogin) {
				that.subscribe = res.data.subscribe;
				if (!that.subscribe && that.followUrl) {
					setTimeout(function() {
					  that.followHid = true;
					}, 200);
				} else {
					that.followHid = false;
				}
			  } else {
				that.followHid = false;
			  }
		  }).catch(err => {
			  that.$dialog.error(err);
		  });
	  },
	  
	  // 轮播图跳转
	  goUrl(index) {
		var that = this;
	    let url = that.banner_jump_url[index];
	    let newStr = url.indexOf("http") === 0;
	    if (newStr) {
	      window.location.href = url;
	    } else {
	      this.$router.push({
	        path: url
	      });
	    }
	  },
	  search(){
		  this.$router.push('/search');
	  },
	  menusclick(menusUrl){
		  this.$router.push(menusUrl);
	  },
	  productClick(url){
		  this.$router.push(url);
	  },
	 
	    closeFollow() {
      this.followHid = false;
    },
    followTap() {
      this.followCode = true;
      this.followHid = false;
    },
    closeFollowCode() {
      this.followCode = false;
      this.followHid = true;
    },
    getFollow() {
      follow()
        .then(res => {
          this.followUrl = res.data.path;
        })
        .catch(() => {});
    },
	  
	  
	  
  }
};
</script>
<style scoped>
[v-cloak] {
  display: none;
}
.noscoll{
	height: 100%;
	overflow: hidden;
}
.index_top{
	width: 100%;
	/* height: 15.2rem; */
	/* position: relative; */
	overflow: hidden;
}
.activebg{
	background: url(../../assets/images/index_topbg.png) no-repeat;
	background-size: 100%;
}
.noactivebg{
	background: url(../../assets/images/index_topbg.png) no-repeat;
	background-size: 100%;
}
/* @media only screen and (min-device-width: 414px) and (max-device-width: 736px) and (-webkit-device-pixel-ratio: 3) {
    .index_top{
		height: 15.15rem;
	}
} */
.index {
  background-color: #f3f3f3;
}

.index .follow {
  z-index: 100000;
}
.search{
	width: 94%;
	border-radius: 50px;
	margin: 0.2rem auto;
	margin-top: 0.9rem;
	height: 0.52rem;
	line-height: 0.52rem;
	background-color: #fff;
	/* padding: 0 5px; */
	color: #ccc;
	/* position: absolute;
	top: 0.86rem;
	left: 3%; */
	font-size: 0.26rem;
}
.sousuo{
	display: inline-block;
	width: 0.65rem;
	text-align: center;
	float: left;
}
.active{
	width: 94%;
	background-color: #fff;
	/* position: absolute;
	top: 1.6rem;
	left: 3%; */
	border-radius: 5px;
	margin: 0.2rem auto;
	overflow: hidden;
}
.active img{
	display: block;
}
.active_01{
	width: 100%;
}
.active_02{
	width: 100%;
}
.active_03{
	width: 100%;
}
.activebox2{
	width: 94%;
	background-color: #fff;
	/* position: absolute;
	top: 7.5rem;
	left: 3%; */
	border-radius: 5px;
	margin: 0.2rem auto;
}
.imgbox{
	position: relative;
}
.activebox2 img{
	display: block;
	border-radius: 5px;
}
.countdown{
	padding-left: 0.35rem;
}
.countdown span{
	color: #ff2210;
	font-size: 0.24rem;
}
.countdown i{
	display: inline-block;
	width: 0.37rem;
	/* height: 0.3rem; */
	/* line-height: 0.3rem; */
	text-align: center;
	color: #fff;
	font-size: 0.26rem;
	background-color: #ff2210;
	border-radius: 2px;
	margin: 0 0.03rem;
}
.end{
	display: inline-block;
	background-color: #ffe8e5;
	border-radius: 5px;
	padding: 0.02rem 0.1rem;
	margin-bottom: 0.2rem;
	margin-right: 0.1rem;
}
.imgbox{
	width: 100%;
}
.imgbox1{
	position: relative;
	width: 40.56%;
	float: left;
}
.imgbox2{
	position: relative;
	width: 59.44%;
	float: left;
}
.shopcar{
	width: 0.5rem;
	position: absolute;
	bottom: 0.3rem;
	right: 0.3rem;
}
.menuslist{
	width: 94%;
	background-color: #fff;
	padding: 0 0.2rem 0.3rem 0.2rem;
	margin: 0.2rem auto;
	margin-bottom: 0;
	border-radius: 5px;
	overflow: hidden;
	/* position: absolute;
	top: 9.95rem;
	left: 3%; */
}
.menuslist li{
	float: left;
	width: 1.2rem;
	height: 1.3rem;
	margin-left: 0.15rem;
	margin-top: 0.2rem;
}
.menuslist li:nth-of-type(5n+1){
	margin-left: 0;
}
.menuslist li dl{
	text-align: center;
}
.menuslist li dl dt img{
	width: 75%;
}
.menuslist li dl dd{
	text-align: center;
	font-size: 0.22rem;
}
.index .banner{
	width: 94%;
	height: auto;
	margin: 0.2rem auto;
	border-radius: 5px;
}
.index .banner img{
	width: 100%;
	height: auto;
}
.ad-img{
	margin-bottom: 0.2rem;
}
.productlist{
	/* margin: 0 auto; */
	/* width: 90%; */
	overflow: hidden;
	padding: 0 0.2rem;
}
.productlist li{
	/* background-color: #fff; */
	width: 100%;
	margin-top: -0.02rem;
	/* padding: 0 0.2rem 0.2rem 0.2rem; */
	/* float: left; */
	/* margin: 0.2rem 0 0 0.2rem; */
	/* border-radius: 5px; */
}
/* .productlist li:nth-child(15){
	margin-top: 0.2rem;
} */
.productlist li img{
	display: block;
	width: 100%;
}
/* .productlist li:nth-of-type(2n+1){
	margin-left: 0;
} */
.productlist li dl dt img{
	width: 100%;
}
.product_name{
	width: 100%;
	height: 40px;
	overflow: hidden;
}
.product_price{
	display: inline-block;
	color: #ff2723;
	font-size: 0.36rem;
	font-weight: bold;
}
.otprice{
	color: #737373;
	text-decoration: line-through;
	margin-left: 0.1rem;
}
.ad{
	display: block;
	width: 94%;
	margin: 0.2rem auto;
}
.zhuantiTop{
	margin-top: 0.2rem;
	padding: 0 0.2rem;
}
.zhuantiTop img,.ad img{
	display: block;
	width: 100%;
}
.index_footer{
	margin-top: 0.2rem;
	margin-bottom: 12%;
}
.index_footer img{
	width: 100%;
}
#mask{
	width: 100%;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 999;
	background-color: rgba(0,0,0,0.8);
}
.mask_img{width: 75%;display: block; margin: 20% auto;margin-bottom: 5%;}
.mask_close{width: 0.7rem;display: block;margin: 0 auto;}
@media only screen and (min-device-width: 414px) and (max-device-width: 736px) and (-webkit-device-pixel-ratio: 3) {
    .mask_img{
		/* width: 80%; */
		/* margin-top: 28%; */
	}
}
@media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-device-pixel-ratio: 2) {
    .mask_img{
		width: 70%;
		margin-top: 10%;
	}
}
@media only screen 
  and (device-width : 375px) 
  and (device-height : 812px) 
  and (-webkit-device-pixel-ratio : 3) {
    .mask_img{
    	/* width: 74%; */
		margin-top: 20%;
    }  
}


/* //iphone Xs Max */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio:3) {
	.mask_img{
		/* width: 76%; */
		margin-top: 22%;
	}
}

 

/* //iphone XR */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio:2) {
	.mask_img{
		margin-top: 20%;
	}
}
@media screen and (min-width:960px){
	.search{
		margin: 0.45rem auto 0.1rem auto;
		font-size: 0.13rem;
		height: 0.26rem;
		line-height: 0.26rem;
	}
	.iconfont{
		font-size: 0.18rem;
	}
	.sousuo{
		width: 0.32rem;
	}
	.menuslist li{
		width: 0.6rem;
		margin-left: 0.07rem;
		margin-top: 0.1rem;
	}
	.menuslist li dl dd{
		font-size: 0.11rem;
		height: 0.18rem;
	}
	.menuslist{
		padding: 0 0.1rem 0.15rem 0.1rem;
		margin-top: 0.1rem;
	}
	.index .banner{
		margin: 0.1rem auto;
	}
	.zhuantiTop{
		margin-top: 0;
	}
	.zhuantiImg2{
		margin-left: 0.1rem;
	}
}
</style>
